// Mock data for Otis Trademark website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "CEO, TechNova Solutions",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85",
    content: "Otis Trademark made our brand registration process seamless. Their attention to detail and expert guidance gave us complete confidence in protecting our intellectual property. Highly recommend their services!"
  },
  {
    id: 2,
    name: "Marcus Johnson",
    role: "Founder, Urban Threads Apparel",
    image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85",
    content: "As an Amazon seller, protecting my brand was crucial. The team at Otis Trademark handled everything from trademark registration to Brand Registry enrollment. Professional, fast, and affordable!"
  },
  {
    id: 3,
    name: "David Chen",
    role: "CTO, Innovate Labs",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85",
    content: "Their patent services exceeded our expectations. The attorneys are knowledgeable, responsive, and truly care about protecting your innovations. We've secured three patents with their help!"
  },
  {
    id: 4,
    name: "Elena Rodriguez",
    role: "Author & Content Creator",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85",
    content: "When my creative work was being copied without permission, Otis Trademark stepped in with swift copyright enforcement. They recovered damages and stopped the infringement completely. True professionals!"
  },
  {
    id: 5,
    name: "James Patterson",
    role: "Managing Director, BuildRight Construction",
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg",
    content: "From LLC formation to trademark protection, they've been our legal partners every step of the way. Their transparent pricing and clear communication made everything stress-free."
  },
  {
    id: 6,
    name: "Priya Sharma",
    role: "Entrepreneur, Wellness Co.",
    image: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg",
    content: "I needed comprehensive trademark monitoring for my growing wellness brand. Otis Trademark's proactive approach caught potential conflicts early and saved me from costly disputes. Invaluable service!"
  }
];

export const coreServices = [
  {
    id: 1,
    title: "Trademark Registration",
    description: "Establish commanding market presence through strategic trademark registration that delivers ironclad protection for your brand assets and competitive positioning.",
    link: "/services/trademark"
  },
  {
    id: 2,
    title: "Copyright Registration",
    description: "Shield your original creative content with specialized copyright registration that ensures comprehensive legal protection for your intellectual creations.",
    link: "/services/copyright"
  },
  {
    id: 3,
    title: "Patent Services",
    description: "Transform innovative concepts into defensible intellectual property through sophisticated patent strategies encompassing research, filing, and enforcement.",
    link: "/services/patent"
  },
  {
    id: 4,
    title: "Company Formation",
    description: "Launch your enterprise with optimal legal architecture—expertly structured LLCs, Corporations, or Non-Profit entities tailored to your business model.",
    link: "/services/company-formation"
  }
];

export const servicesMenu = [
  {
    id: 1,
    name: "Trademark Services",
    icon: "Scale",
    description: "Comprehensive trademark protection for your brand",
    subServices: [
      { 
        name: "Trademark Search & Registration", 
        link: "/services/trademark-search-registration",
        oneLiner: "Secure exclusive rights to your brand name and logo"
      },
      { 
        name: "Trademark Clearance Searches", 
        link: "/services/trademark/clearance",
        oneLiner: "Verify your mark's availability before filing"
      },
      { 
        name: "Trademark Application Preparation", 
        link: "/services/trademark/application",
        oneLiner: "Expert preparation of USPTO trademark applications"
      },
      { 
        name: "Trademark Office Actions", 
        link: "/services/trademark/office-actions",
        oneLiner: "Professional responses to USPTO objections"
      },
      { 
        name: "Trademark Monitoring", 
        link: "/services/trademark/monitoring",
        oneLiner: "Continuous surveillance of potential infringements"
      },
      { 
        name: "Statement Of Use Filings", 
        link: "/services/trademark/statement-of-use",
        oneLiner: "Complete your trademark registration process"
      },
      { 
        name: "Trademark Change of Ownership", 
        link: "/services/trademark/ownership-change",
        oneLiner: "Transfer trademark rights seamlessly"
      },
      { 
        name: "Trademark Portfolio Management", 
        link: "/services/trademark/portfolio",
        oneLiner: "Maintain and optimize your trademark portfolio"
      }
    ]
  },
  {
    id: 2,
    name: "Copyright Services",
    icon: "Copyright",
    description: "Protect your creative works and intellectual content",
    subServices: [
      { 
        name: "Copyright Registration", 
        link: "/services/copyright/registration",
        oneLiner: "Register your creative works with the Copyright Office"
      },
      { 
        name: "Copyright Enforcement", 
        link: "/services/copyright/enforcement",
        oneLiner: "Stop unauthorized use of your copyrighted content"
      },
      { 
        name: "Copyright Assignments and Licensing", 
        link: "/services/copyright/assignments",
        oneLiner: "Transfer or license your copyright rights"
      },
      { 
        name: "Copyright Litigation", 
        link: "/services/copyright/litigation",
        oneLiner: "Defend or pursue copyright infringement claims"
      },
      { 
        name: "Copyright Portfolio Management", 
        link: "/services/copyright/portfolio",
        oneLiner: "Manage and protect your copyright assets"
      },
      { 
        name: "Digital Millennium Copyright Act", 
        link: "/services/copyright/dmca",
        oneLiner: "DMCA takedown notices and compliance"
      }
    ]
  },
  {
    id: 3,
    name: "Patent Services",
    icon: "Lightbulb",
    description: "Secure your innovations and inventions",
    subServices: [
      { 
        name: "Patent Searches", 
        link: "/services/patent/searches",
        oneLiner: "Comprehensive prior art and patentability searches"
      },
      { 
        name: "Office Actions & Amendments", 
        link: "/services/patent/office-actions",
        oneLiner: "Respond to USPTO patent examination issues"
      },
      { 
        name: "Patent Applications", 
        link: "/services/patent/applications",
        oneLiner: "Prepare and file utility, design, or provisional patents"
      },
      { 
        name: "Patent Enforcement", 
        link: "/services/patent/enforcement",
        oneLiner: "Protect your patents from infringement"
      }
    ]
  },
  {
    id: 4,
    name: "Company Formation",
    icon: "Building2",
    description: "Establish your business structure properly",
    subServices: [
      { 
        name: "LLC Formation", 
        link: "/services/company/llc",
        oneLiner: "Limited liability protection with flexible management"
      },
      { 
        name: "C Corporation", 
        link: "/services/company/c-corp",
        oneLiner: "Traditional corporate structure for scalable growth"
      },
      { 
        name: "S Corporation", 
        link: "/services/company/s-corp",
        oneLiner: "Tax advantages for small business owners"
      },
      { 
        name: "Non-Profit Organization", 
        link: "/services/company/non-profit",
        oneLiner: "Tax-exempt status for charitable organizations"
      }
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Experienced IP Attorneys",
    description: "Proven track record spanning decades in intellectual property strategy and comprehensive brand defense."
  },
  {
    id: 2,
    title: "Transparent Pricing",
    description: "Straightforward, all-inclusive pricing structure with complete cost visibility from day one."
  },
  {
    id: 3,
    title: "Fast & Reliable Filings",
    description: "Accelerated processing timelines delivering prompt results while maintaining rigorous legal standards."
  },
  {
    id: 4,
    title: "End-to-End Legal Support",
    description: "Complete lifecycle management from strategic consultation through final registration and ongoing protection."
  }
];